<div class="zwi-reference-footer">
  <div class="zwi-reference-controls">
    <div class="zwi-reference-spacer"></div>
    <button (click)="done()" mat-flat-button color="primary">Done</button>
  </div>
</div>
